/**
 * Campaigns Page
 *
 * File: Mythbound.App/src/pages/CampaignsPage.tsx
 * Created: 2026-02-26
 * Last Modified: 2026-02-26
 *
 * PURPOSE:
 * Dedicated /campaigns route — full-page view of all user campaigns with
 * consistent navigation. Wraps DashboardCampaignSection (same component
 * used on the Dashboard) so the /campaigns route renders the full campaign
 * list without requiring the entire Dashboard page layout.
 *
 * ROUTES:
 * - Renders at: /campaigns
 * - Creates at: /campaign/builder
 * - Detail at: /campaigns/:campaignId
 *
 * Pipeline: App.tsx route → CampaignsPage → DashboardCampaignSection → CampaignContext → CampaignService
 *
 * Dependencies: DashboardCampaignSection (named export), Chakra UI Box/VStack
 *
 * EXPORT NOTE:
 * DashboardCampaignSection ships both a named export (used here) and a
 * default export — we use the named form for consistency with the rest of
 * the codebase imports in that file.
 */

import React from 'react';
import { Box, VStack } from '@chakra-ui/react';
// Added 2026-02-26: DashboardCampaignSection has both named + default exports;
// using named export to match how it's consumed across the rest of the codebase.
import { DashboardCampaignSection } from '../components/dashboard/DashboardCampaignSection';

const CampaignsPage: React.FC = () => (
  <Box p={{ base: 4, md: 8 }}>
    <VStack align="start" spacing={8} w="full">
      <DashboardCampaignSection />
    </VStack>
  </Box>
);

export default CampaignsPage;
